module.exports = __webpack_public_path__ + "u2f_70x70.d5897ef1a6e745da2959495574ff3929.png";